import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components

// index page sections


import {getStats} from "../../components/helpers/StatsHelpers";
import {SeoHelper} from "../../components/helpers/SeoHelper";

class AcceptableUsePolicy extends React.Component {
  state = {
    songBookCount: null
  };

  constructor(props) {
    super(props);
    getStats.call(this);
  }

  render() {
    return (
      <>
        <SeoHelper
            uri="/about-us"
            title="Acceptable Use Policy | Scripture-Based Worship Planning"
            description="The Worship Bible's Acceptable Use Policy"
        />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>website disclaimer</span>
                      </h1>
                      {/*<p className="lead text-white">*/}
                      {/*  The design system comes with four pre-built pages to*/}
                      {/*  help you get started faster. You can change the text and*/}
                      {/*  images and you're good to go.*/}
                      {/*</p>*/}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="12">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          {/*<div className="icon icon-shape icon-shape-primary rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-check-bold" />*/}
                          {/*</div>*/}
                          {/*<div dangerouslySetInnerHTML={this.privacyPolicy} />*/}
                          <Row className="justify-content-center">
                            <p className="description mt-3">
                              <img src={require("../../assets/images/termly-logo.png")} alt="Termly"/>
                            </p>
                          </Row>
                          <div className="WordSection1">
                            <p className="MsoNormal"><b><br/>
                              WEBSITE DISCLAIMER</b>
                            </p>

                            <p className="MsoNormal"><b>Last updated&nbsp;October 03, 2024</b></p>

                            <p className="MsoNormal">
                              This Acceptable Use Policy (<b>"Policy"</b>) is part of our __________ (<b>"Legal Terms"</b>) and should therefore be read alongside our main Legal Terms: __________. If you do not agree with these Legal Terms, please refrain from using our Services. Your continued use of our Services implies acceptance of these Legal Terms.
                            </p>

                            <p className="MsoNormal">
                              Please carefully review this Policy which applies to any and all:
                            </p>

                            <p className="MsoNormal">
                              <ul style={{marginTop: 0 + 'cm'}} type="none">
                                <li>(a) uses of our Services (as defined in "Legal Terms")</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="none">
                                <li>(b) forms, materials, consent tools, comments, post, and all other content available on the Services (<b>"Content"</b>)</li>
                              </ul>
                            </p>

                            <p className="MsoNormal"><b>WHO WE ARE</b></p>

                            <p className="MsoNormal">
                              We are The Worship Bible (<b>"Company," "we," "us,"</b> or <b>"our"</b>) a company registered in __________ at __________, __________. We operate , as well as any other related products and services that refer or link to this Policy (collectively, the <b>"Services</b>").
                            </p>

                            <p className="MsoNormal"><b>USE OF THE SERVICES</b></p>

                            <p className="MsoNormal">
                              When you use the Services, you warrant that you will comply with this Policy and with all applicable laws.
                            </p>

                            <p className="MsoNormal">
                              You also acknowledge that you may not:
                            </p>

                            <p className="MsoNormal">
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Systematically retrieve data or other content from the Services to create or compile, directly or indirectly, a collection, compilation, database, or directory without written permission from us.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Make any unauthorized use of the Services, including collecting usernames and/or email addresses of users by electronic or other means for the purpose of sending unsolicited email, or creating user accounts by automated means or under false pretenses.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Circumvent, disable, or otherwise interfere with security-related features of the Services, including features that prevent or restrict the use or copying of any Content or enforce limitations on the use of the Services and/or the Content contained therein.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Engage in unauthorized framing of or linking to the Services.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Trick, defraud, or mislead us and other users, especially in any attempt to learn sensitive account information such as user passwords.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Make improper use of our Services, including our support services or submit false reports of abuse or misconduct.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Engage in any automated use of the Services, such as using scripts to send comments or messages, or using any data mining, robots, or similar data gathering and extraction tools.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Interfere with, disrupt, or create an undue burden on the Services or the networks or the Services connected.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Attempt to impersonate another user or person or use the username of another user.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Use any information obtained from the Services in order to harass, abuse, or harm another person.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Use the Services as part of any effort to compete with us or otherwise use the Services and/or the Content for any revenue-generating endeavor or commercial enterprise.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Decipher, decompile, disassemble, or reverse engineer any of the software comprising or in any way making up a part of the Services, except as expressly permitted by applicable law.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Attempt to bypass any measures of the Services designed to prevent or restrict access to the Services, or any portion of the Services.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Harass, annoy, intimidate, or threaten any of our employees or agents engaged in providing any portion of the Services to you.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Delete the copyright or other proprietary rights notice from any Content.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Copy or adapt the Services’ software, including but not limited to Flash, PHP, HTML, JavaScript, or other code.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Upload or transmit (or attempt to upload or to transmit) viruses, Trojan horses, or other material, including excessive use of capital letters and spamming (continuous posting of repetitive text), that interferes with any party’s uninterrupted use and enjoyment of the Services or modifies, impairs, disrupts, alters, or interferes with the use, features, functions, operation, or maintenance of the Services.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Upload or transmit (or attempt to upload or to transmit) any material that acts as a passive or active information collection or transmission mechanism, including without limitation, clear graphics interchange formats ("gifs"), 1×1 pixels, web bugs, cookies, or other similar devices (sometimes referred to as "spyware" or "passive collection mechanisms" or "pcms").</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Except as may be the result of standard search engine or Internet browser usage, use, launch, develop, or distribute any automated system, including without limitation, any spider, robot, cheat utility, scraper, or offline reader that accesses the Services, or using or launching any unauthorized script or other software.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Disparage, tarnish, or otherwise harm, in our opinion, us and/or the Services.</li>
                              </ul>
                              <ul style={{marginTop: 0 + 'cm'}} type="square">
                                <li>Use the Services in a manner inconsistent with any applicable laws or regulations.</li>
                              </ul>
                            </p>

                            <p className="MsoNormal"><b>CONSEQUENCES OF BREACHING THIS POLICY</b></p>

                            <p className="MsoNormal">
                              The consequences for violating our Policy will vary depending on the severity of the breach and the user's history on the Services, by way of example:
                            </p>

                            <p className="MsoNormal">
                              We may, in some cases, give you a warning, however, if your breach is serious or if you continue to breach our Legal Terms and this Policy, we have the right to suspend or terminate your access to and use of our Services and, if applicable, disable your account. We may also notify law enforcement or issue legal proceedings against you when we believe that there is a genuine risk to an individual or a threat to public safety.
                            </p>

                            <p className="MsoNormal">
                              We exclude our liability for all action we may take in response to any of your breaches of this Policy.
                            </p>

                            <p className="MsoNormal"><b>HOW CAN YOU CONTACT US ABOUT THIS POLICY?</b></p>

                            <p className="MsoNormal">
                              If you have any further questions or comments, you may contact us by:
                            </p>

                            <p className="MsoNormal">
                              The Worship Bible,<br/>
                              United Kingdom
                            </p>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        {/*</main>*/}
        
      </>
    );
  }
}

export default AcceptableUsePolicy;
